export const AI_OPERATOR_CONFIG_CHUNK = 'AiOperatorConfig';
